import { create } from "zustand";

type ConnectedAppsState = {
  services: any;
  hasDestination: boolean;
  imanageConnected: boolean;
  agentEnabled: boolean;
  desktopAgentStatus: any;
  chromeExtensionStatus: any;
  edgeExtensionStatus: any;
  supportEnabled: boolean;
  showHeartBeatDialog: boolean;
  auditLoggingViolation: boolean;
  setServices: (services: any) => void;
  setHasDestination: (hasDestination: boolean) => void;
  setImanageConnected: (imanageConnected: boolean) => void;
  setAgentEnabled: (agentEnabled: boolean) => void;
  setDesktopAgentStatus: (desktopAgentStatus: any) => void;
  setChromeExtensionStatus: (chromeExtensionStatus: any) => void;
  setEdgeExtensionStatus: (edgeExtensionStatus: any) => void;
  setSupportEnabled: (supportEnabled: boolean) => void;
  setShowHeartBeatDialog: (showHeartBeatDialog: boolean) => void;
  setAuditLoggingViolation: (auditLoggingViolation: boolean) => void;
};

export const useConnectedAppsStore = create<ConnectedAppsState>((set) => ({
  services: false,
  hasDestination: false,
  imanageConnected: false,
  agentEnabled: false,
  desktopAgentStatus: null,
  chromeExtensionStatus: null,
  edgeExtensionStatus: null,
  supportEnabled: false,
  showHeartBeatDialog: false,
  auditLoggingViolation: false,
  setServices: (services) => set({ services }),
  setHasDestination: (hasDestination) => set({ hasDestination }),
  setImanageConnected: (imanageConnected) => set({ imanageConnected }),
  setAgentEnabled: (agentEnabled) => set({ agentEnabled }),
  setDesktopAgentStatus: (desktopAgentStatus) => set({ desktopAgentStatus }),
  setChromeExtensionStatus: (chromeExtensionStatus) => set({ chromeExtensionStatus }),
  setEdgeExtensionStatus: (edgeExtensionStatus) => set({ edgeExtensionStatus }),
  setSupportEnabled: (supportEnabled) => set({ supportEnabled }),
  setShowHeartBeatDialog: (showHeartBeatDialog) => set({ showHeartBeatDialog }),
  setAuditLoggingViolation: (auditLoggingViolation) => set({ auditLoggingViolation }),
}));
